module.exports = __webpack_public_path__ + "static/media/tree.286c72c3.svg";